import { UrlMatchResult, UrlSegment } from "@angular/router";

export const routes = [
	{
		path: 'v2',
		children: [
			{
				matcher: catalogUrlMatcher,
				loadComponent: () =>
					import("./catalog-integration/catalog-integration.component").then(
						m => m.CatalogIntegrationComponent
					)
			},
			{
				matcher: catalogItemUrlMatcher,
				loadComponent: () =>
					import("./catalog-item-integration/catalog-item-integration.component").then(
						m => m.CatalogItemIntegrationComponent
					)
			},
			{
				matcher: integrationNotFoundUrlMatcher,
				loadComponent: () =>
					import("../errorpages/page-not-found/page-not-found.component").then(
						m => m.PageNotFoundComponent
					)
			}
		]
	},
	{
		path: 'account-handler',
		loadComponent: () =>
			import("./account-handler/account-handler.component").then(
				m => m.AccountHandlerComponent
			)
	},
	{
		matcher: integrationNotFoundUrlMatcher,
		loadComponent: () =>
			import("../errorpages/page-not-found/page-not-found.component").then(
				m => m.PageNotFoundComponent
			)
	}
]


// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function catalogUrlMatcher(urlSegments: UrlSegment[]): UrlMatchResult {
	if (urlSegments.length < 2) {
		return null;
	}

	// Liste für verarbeitete URLSegmente
	const consumed = [];

	if (urlSegments[0].toString() === "catalog" && urlSegments[1]) {
		const params: { [name: string]: UrlSegment } = { key: urlSegments[1] };
		consumed.push(urlSegments[0]);
		consumed.push(urlSegments[1]);

		if (
			urlSegments[2] &&
			urlSegments[3] &&
			urlSegments[2].toString() === "guid"
		) {
			consumed.push(urlSegments[2]);
			consumed.push(urlSegments[3]);

			params.catalogItemGuid = urlSegments[3];
		}

		if (urlSegments[urlSegments.length - 1].toString() === 'search') {
			params.view = urlSegments[urlSegments.length - 1];
			consumed.push(urlSegments[urlSegments.length - 1]);
		}
		return { consumed, posParams: params };
	}
	return null;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function catalogItemUrlMatcher(urlSegments: UrlSegment[]): UrlMatchResult {
	if (urlSegments.length < 3) {
		return null;
	}

	// Liste für verarbeitete URLSegmente
	const consumed = [];

	if (
		urlSegments[0].toString() === "catalogItem"
		&& urlSegments[1].toString() === "guid"
		&& urlSegments[2]) {
		const params: { [key: string]: UrlSegment } = {
			catalogItemGuid: urlSegments[2]
		};
		consumed.push(urlSegments[0]);
		consumed.push(urlSegments[1]);
		consumed.push(urlSegments[2]);

		if (
			urlSegments[3] &&
			urlSegments[4] &&
			urlSegments[3].toString() === "attachment"
		) {
			consumed.push(urlSegments[3]);
			consumed.push(urlSegments[4]);
			params.attachmentId = urlSegments[4];
		}

		return { consumed, posParams: params };
	}
	return null;
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function integrationNotFoundUrlMatcher(urlSegments: UrlSegment[]): UrlMatchResult {
	const excludeEndings = ['.js', '.css', '.json', '.xml', '.worker'];
	if (excludeEndings.some(ending => urlSegments[urlSegments.length - 1].path.endsWith(ending))) {
		return undefined;
	}

	const consumed = [];
	consumed.push(...urlSegments);
	return { consumed };
}